'use client'
import { usePathname, useRouter } from 'next/navigation'
import React, { useEffect, useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

type Props = {
    searchParams: URLSearchParams
}

const FilterVenteId = ({ searchParams }: Props) => {
    const pathName = usePathname()
    const params = useMemo(() => new URLSearchParams(searchParams), [searchParams])
    const router = useRouter()

    const [numero, setNumero] = useState<string>('')
    const [debouncedNumero] = useDebounce(numero, 500)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value;
        if (/^\d+$/.test(val) || val === '') {
            setNumero(val)
        }
    }

    useEffect(() => {
        if (params.has('numero')) {
            setNumero(params.get('numero') || '')
        } else {
            setNumero('')
        }
    }, [params])

    useEffect(() => {
        if (params.has('numero')) {
            params.set('page', '1')
        }
        params.delete('numero')
        if (debouncedNumero) {
            params.append('numero', debouncedNumero)
        }
        router.push(pathName + '?' + params.toString())
    }, [debouncedNumero, params, pathName, router])

    return (
        <div className="relative w-full lg:w-1/3">
            <input
                type="text"
                id="numero"
                name="numero"
                placeholder="Numéro de la vente"
                className="w-full px-2 py-[8px] text-sm grow rounded-md border border-zinc-300 bg-white text-zinc-700 focus:border-zinc-500 focus:ring-zinc-500 focus:ring-1 duration-700 hover:border-zinc-500 hover:ring-zinc-500 hover:ring-1"
                onChange={handleChange}
                value={numero}
            />
            {numero && (
                <button
                    type="button"
                    className="absolute top-1/2 right-3 transform -translate-y-1/2 text-zinc-700 hover:text-zinc-500"
                    onClick={() => setNumero('')}
                >
                    &#x2715; {/* Croix */}
                </button>
            )}
        </div>
    )
}

export default FilterVenteId